export default "__VITE_ASSET__NMGQyxba__"